import FocusStatus from 'assets/status/focus.svg';
import WorkingStatus from 'assets/status/working.svg';
import NotWorkingStatus from 'assets/status/not_working.svg';
import OfflineStatus from 'assets/status/offline.svg';

export enum StatusType {
  WORKING_INTERRUPTIBLE = 'WORKING_INTERRUPTIBLE',
  FOCUSED = 'FOCUSED',
  NON_WORKING_INTERRUPTIBLE = 'NON_WORKING_INTERRUPTIBLE',
  OFFLINE = 'OFFLINE',
}

interface StatusItemConfig {
  label: string;
  icon: string;
}

type StatusConfig = Record<StatusType, StatusItemConfig>;

export const statusConfig: StatusConfig = {
  [StatusType.WORKING_INTERRUPTIBLE]: {
    label: 'Working',
    icon: WorkingStatus,
  },
  [StatusType.FOCUSED]: {
    label: 'Focused',
    icon: FocusStatus,
  },
  [StatusType.NON_WORKING_INTERRUPTIBLE]: {
    label: 'Inactive',
    icon: NotWorkingStatus,
  },
  [StatusType.OFFLINE]: {
    label: 'Offline',
    icon: OfflineStatus,
  },
};
